<template>
  <div class="game-words-container">
    <!-- 返回按钮 -->
    <div class="back-btn" @click="goBack">
      <img src="./images/icon-back.png" />
    </div>

    <div class="game-words-aside">
      <div class="game-words-tip">
        <p class="tip-title">队员要拿出读音规则抄写本，按照以下4步完成训练：</p>
        <p class="tip-content">
          1. 以词汇或者词组为单位，先<span class="tip-content-red">听一遍音频</span>，感受<span class="tip-content-red">音节发音</span>;
        </p>
        <p class="tip-content">
          2. 按照音节抄写词汇，并划好音节，按要求<span class="tip-content-red">抄写2遍</span>；
        </p>
        <p class="tip-content">
          3. 词汇抄写2遍后，要<span class="tip-content-red">读2遍</span>；
        </p>
        <p class="tip-content">
          4. 整个关卡的词汇或者词组抄写完成后，要<span class="tip-content-red">整体读一遍</span>。
        </p>
      </div>
      <img src="./images/girl.png" class="game-words-girl">
    </div>

    <div class="game-words-main">
      <img src="./images/title-bg.png" class="game-words-title" />
      <PlayerList
        class="player-list"
        :audio-list="audioList"
        @play="handlePlay"
        @ended="handleEnded"
      />
    </div>
  </div>
</template>

<script>
import laudio from '@/utils/laudio'
import UPModel from '@/models/imgup'
import {apiGetGameWordsList} from '@/models/study2'
// import lLearnCircle from '@/views/learn-new/components/l-learn-circle'
import PlayerList from './components/PlayerList.vue'
import { processData } from './util'

const imgUp = new UPModel()


export default {
  name: 'l-game-words',
  props: {
    autoplay: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    PlayerList,
  },
  data() {
    return {
      stage: 101,
      audioList: [],
      currentSong: {},
      laudio: null,
      audio: {
        target: null,
        play: false,
        totalTime: '',
        currentTime: '00:00:00',
        percent: 0,
        src: '',
        status: '',
        duration: 0,
      },
    }
  },
  methods: {
    goBack() {
      this.$router.go(-1)
    },
    async getPlayList(stage) {
      const res = await apiGetGameWordsList(stage)
      const list = res.data.reduce((acc, cur) => {
        acc.push(...cur.attrs?.words??[])
        return acc
      }, []).map(item => ({
        ...item,
        playing: false,
      }))
      this.audioList = processData(list)
    },
    async getSongUrl(audio) {
      this.$lLoading.show()
      try {
        const res = await imgUp.getAudioUrl([audio.sound])
        this.$lLoading.hide()
        audio.src = res.data[0].url
        this.audio.src = res.data[0].url
      } catch (err) {
        this.$lLoading.hide()
        console.log(err.msg)
      }
    },
    async handlePlay(audio) {
      if (this.currentSong.sound && (this.currentSong.sound !== audio.sound)) {
          this.currentSong.playing = false
      }
      this.currentSong = audio
      if (!audio.playing) {
        this.laudio.pause()
      } else {
        if (!audio.src) {
          await this.getSongUrl(audio)
        }
        if (!this.laudio) {
          await this._initAudio(audio.src)
        }
        if (this.laudio.src !== audio.src) {
          this.laudio.src = audio.src
        }
        this.laudio.play()
      }
    },
    async _initAudio(src) {
      this.laudio = laudio({
        autoplay: this.autoplay,
        src,
      })
      this.laudio.addEventListener('loadedmetadata', () => {
        this.audio.totalTime = this._format(this.laudio.duration)
        this.audio.duration = this.laudio.duration
      })
      this.laudio.addEventListener('ended', () => {
        this.currentSong.playing = false
      })
      this.laudio.addEventListener('timeupdate', () => {
        this.audio.currentTime = this._format(this.laudio.currentTime)
        this.audio.percent = (this.laudio.currentTime / this.laudio.duration) * 100
      })
    },
    handleEnded() {
      const currentIndex = this.audioList.findIndex(audio => audio.sound === this.currentSong.sound)
      if (currentIndex !== -1 && currentIndex < this.audioList.length - 1) {
        this.handlePlay(this.audioList[currentIndex + 1])
      } else {
        this.currentSong.playing = false
      }
    },
    togglePlayStatus() {
      if (this.currentSong.playing) {
        this.laudio.pause()
      } else {
        this.laudio.play()
      }
      this.currentSong.playing = !this.currentSong.playing
    },
    
    // 格式时间
    _format(timezone) {
      // 取整，防止计算大浮点数
      timezone = parseInt(timezone)
      let time = []
      time[0] = parseInt(timezone / 60 / 60)
      time[1] = parseInt((timezone - time[0] * 60 * 60) / 60)
      time[2] = parseInt((timezone - time[0] * 60 * 60) % 60)

      time = time.map((item) => {
        return this._padStart(item)
      })
      return time.join(':')
    },
    _padStart(number) {
      return number < 10 ? `0${number}` : number
    },
  },
  created() {
    this.stage = Number(this.$route.query.id)
    this.getPlayList(this.stage)
  },
  destroyed() {
    this.laudio ? this.laudio.pause() : null
  },
}
</script>

<style scoped>
.game-words-container {
  display: flex;
  width: 100%;
  height: 100%;
  background: url('./images/game-words-bg.png') center/100% 100% no-repeat;
}

.back-btn {
  position: absolute;
  top: 30px;
  left: 30px;
  z-index: 10;
  cursor: pointer;
}
.back-btn img {
  display: block;
  width: 80px;
}

.game-words-aside {
  position: relative;
  flex: 1;
}
.game-words-tip {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 1;
  width: 420px;
  height: 347px;
  padding: 42px 44px 62px;
  margin-top: 90px;
  background: url('./images/tip-bg.png') center/100% 100% no-repeat;
}
.tip-title {
  font-size: 22px;
  font-weight: bold;
  color: #438904;
  text-align: left;
}
.tip-content {
  font-size: 20px;
  font-weight: bold;
  color: #4E4C50;
  text-align: left;
  margin-top: 20px;
}
.tip-content-red {
  color: #FF0000;
}
.game-words-girl {
  position:absolute;
  left: 20px;
  bottom: 20px;
  width: 430px;
  height: 450px;
}
.game-words-main {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
  margin: 0 auto;
  margin-right: 20px;
}
.player-list {
  overflow: hidden;
}
.game-words-title {
  width: 618px;
  height: 100px;
}
</style>
